import styled from 'styled-components'

const FilterContainer = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: space-between;
  padding: 2px 0 32px;
  width: 160px;
`

export const s = {
  FilterContainer
}
